import { toast } from 'components';
import { lacleStore } from 'store';
import { ExportApi } from './api';

const ExportActioner = {
  download: (type, filters) => {
    return ExportApi.download(type, filters)
      .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;

        const date = new Date().toISOString().split('T')[0];
        link.download = `${type}_${date}.xlsx`;

        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);

        const messages = lacleStore.getState().I18n.messages.toast.success;
        toast.success(messages.successFullyExported || 'Export réussi');
      })
      .catch(err => {
        const messages = lacleStore.getState().I18n.messages.toast.error;
        const msg = err.description ? err.description : messages.errorOccured;
        toast.error(msg);
        throw err;
      });
  },

  getTypes: () => {
    return ExportApi.getTypes()
      .then(res => res)
      .catch(err => {
        const messages = lacleStore.getState().I18n.messages.toast.error;
        toast.error(messages.errorOccured);
        throw err;
      });
  },
};

export { ExportActioner };
